import {
  getFontCss,
  HoverableLinkSizes,
  styleConstants,
} from '@paywithextend/components'
import React from 'react'
import { useSelector } from 'react-redux'
import ResourceCenterLink from 'src/components/ResourceCenterLink/ResourceCenterLink'
import { SupportedBrands } from 'src/enums'
import { useTranslate } from 'src/localization/Trns'
import { selectBrandName } from 'src/redux/selectors/session.selectors'
import { css } from 'styled-components'

interface OnboardingFlowCustomerSupportBannerMessageProps {
  linkProps: {
    color: string
    hoverColor: string
  }
}

const OnboardingFlowCustomerSupportBannerMessage: React.FC<
  OnboardingFlowCustomerSupportBannerMessageProps
> = (props) => {
  const translate = useTranslate()

  const brandName = useSelector(selectBrandName)

  return (
    <>
      {brandName === SupportedBrands.PacWest ||
      brandName === SupportedBrands.Boc
        ? translate(
            'Need help? Visit our ${resourceCenter} for support and contact options.',
            {
              resourceCenter: (
                <span
                  css={css`
                    ${getFontCss(
                      12,
                      styleConstants.colors.green_dark,
                      styleConstants.fontFamilies.medium,
                    )};
                  `}
                >
                  <ResourceCenterLink
                    size={HoverableLinkSizes.Small}
                    underline
                    css={css`
                      color: ${props.linkProps.color};
                      &:hover {
                        color: ${props.linkProps.hoverColor};
                      }
                    `}
                  />
                </span>
              ),
            },
          )
        : translate(
            'Need help? Visit our ${resourceCenter} for support and contact options.',
            {
              resourceCenter: (
                <ResourceCenterLink
                  size={HoverableLinkSizes.Small}
                  underline
                  css={css`
                    color: ${props.linkProps.color};
                    &:hover {
                      color: ${props.linkProps.hoverColor};
                    }
                  `}
                />
              ),
            },
          )}
    </>
  )
}

export default OnboardingFlowCustomerSupportBannerMessage
